import React from 'react';
import VerticalList from '../../Basic/Lists/VerticalList/VerticalList.mjs';
import { StyledRegionContainer, StyledListContainer } from './DesktopNavigation.styles.mjs';

const DesktopRegionSelector = ({ onChange, selectedRegion, heading, regions }) => {
    return (React.createElement(StyledRegionContainer, null,
        React.createElement(StyledListContainer, null,
            React.createElement(StyledListContainer, null,
                React.createElement(VerticalList, { onClick: ({ id, name }) => onChange({ id, name }), heading: heading, withIcon: true, selectedOption: selectedRegion, options: regions })))));
};

export { DesktopRegionSelector as default };
//# sourceMappingURL=DesktopRegionSelector.mjs.map
